import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { UserModel } from './user.model';
import { Observable } from 'rxjs';
import { ResourceData } from '@app/shared/abstract/resource.data';

@Injectable({
  providedIn: 'root',
})
export class UserService extends AbstractEntityService<UserModel> {
  constructor(http: HttpClient) {
    super('/api/users', http);
  }

  archive(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}${this.basePath}/${id}`);
  }

  restore(id: number): Observable<UserModel> {
    return this.http.post<UserModel>(`${this.apiUrl}${this.basePath}/${id}/restore`, {});
  }

  reactivateArchived(payload: object): Observable<ResourceData<UserModel>> {
    return this.http.post<ResourceData<UserModel>>(`${this.apiUrl}${this.basePath}/reactivate-archived`, JSON.stringify(payload));
  }
}
